export enum OrderTable {
	CUSTOMER_ORDERS = "CUSTOMER_ORDERS",
	PRODUCT_TO_CUSTOMER_ORDER = "PRODUCT_TO_CUSTOMER_ORDER",
	PRODUCTS = "# ARTIKEL MASTER LISTE",
}
